/**
 * @category Internal
 */
export var CustomConverterUtils;
(function (CustomConverterUtils) {
    CustomConverterUtils.isString = function (maybeString) {
        return (typeof maybeString === "string");
    };
})(CustomConverterUtils || (CustomConverterUtils = {}));
